<template>
    <div>
        <!-- <password-alert @comfirmPassword="comfirmPassword()"></password-alert> -->
        <table id="userList" class="table" style="width:100%" />

        <v-dialog v-model="editUserDialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    User Information
                </v-card-title>

                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field
                                v-model="emailAddress"
                                v-validate="'required|email'"
                                label="Email *"

                                required
                                :error-messages="errors.collect('Email')"
                                data-vv-name="Email"
                            />
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field
                                v-model="password"
                                v-validate="'required'"
                                label="Password *"
                                type="password"
                                required
                                :error-messages="errors.collect('Password')"
                                data-vv-name="Password"
                                autocomplete="off"
                            />
                        </v-flex>
						
                        <v-flex xs12>
                            <v-autocomplete
                                v-model="selectedDepartment"
                                :items="DepartmentOptions"
                                item-text="name"
                                item-value="id"
                                label="Department"

                                clearable
                                :error-messages="errors.collect('Department')"
                                data-vv-name="Department"
                            />
                        </v-flex>

                        <v-flex xs12>
                            <v-autocomplete
                                v-model="selectedRole"
                                v-validate="'required'"
                                :items="RoleOptions"
                                item-text="name"
                                item-value="value"
                                label="Roles *"

                                clearable
                                :error-messages="errors.collect('Roles')"
                                data-vv-name="Roles"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <div class="white-padding-rem">
                        <v-btn color="primary" @click="EditUser()"> Save </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="isDeleteDialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Are you sure to delete the user?
                </v-card-title>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <div class="white-padding-rem">
                        <v-btn color="primary" @click="confirmDeleteUser()"> Yes </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { roleGetAllForDropdown } from "@/api/role";
import { deleteUser } from "@/api/user";

export default {
  	name: "UserTable",
    props: ["comfirmFn", "SendPasswordResetCode"],

  	data () {
	    return {
	    	TableName: "#userList", 
	    	APIName: "User",

	    	editUserDialog: false,

	    	RoleOptions: [],
	    	selectedRole: null,

	    	DepartmentOptions: [],
	    	selectedDepartment: null,

	    	name: null,
	    	surname: null,
	    	userName: null,
	    	emailAddress: null,
	    	password: null,

	    	SelectedId: null,
            selectedResetEmail: null,

            isDeleteDialog: false
	    };
    },
    watch: {
        comfirmFn() {
            if (this.comfirmFn == true) {
                this.comfirmUpdateUser();
            }
        },
        SendPasswordResetCode() {
            if (this.SendPasswordResetCode == true) {
                this.confirmResetPasswordCode();
            }
        },
    },
    mounted() {
  	this.getUserList();
    },
    methods: {
  	  	getUserList() {
            var self = this;
  			$("#userList").DataTable(dataTableOption({
  				"ajax": {
  					"url": "User/GetAll",
  				},
  				"order": [[ 6, "desc" ]],
  				"columnDefs": [
  					{ targets: "_all", defaultContent: "-" },
  				],
  		        "columns": [
  				   	{ data: "id", title: "ID" },//for checkboxes purpose
  				   	{ data: "userName", title: "Username" },
  				   	{ data: "roleNames", title: "Role" },
  				   	{ data: "emailAddress", title: "Email Address" },
                    { data: "department.name", title: "Department" },
                    // { data: 'isActive', title: 'Is Actived', render: function(data) { if(data) return 'Yes'; else return 'No'; }},
                    { data: "lastLoginTime", title: "Last Login At", render: function(date) { if (date) return self.formatCreationTime(date); } },
                    { data: "creationTime", title: "Created At", render: function(date) { if (date) return self.formatCreationTime(date); } },
  				    { data: "null", title: "Action", "orderable": false, render: function( data, type, row ) {
  				      return `
  				      <div class='tableUserEdit inline-block' data-passingID=` + row.id + `><div class='round-btn grey-text'><i class='fas fa-edit'></i></div></div>
                <div class='tableSendEmail inline-block' data-passingEmail=` + row.emailAddress + `><div class='round-btn grey-text'><i class="fas fa-key"></i></div></div>
  				      <div class='tableActionDelete inline-block' data-passingID=` + row.id + "><div class='round-btn grey-text'><i class='fas fa-trash-alt'></i></div></div>";
  				    } },
  				],
                "select": {
                    style: "single"
                },
  				"exportTitle": "User Table",
  			}));
  			this.tableUserEdit(this.TableName, this.APIName);
            this.tableSendEmail(this.TableName);
            this.tableActionDelete(this.TableName, this.APIName);
  			// this.tableActionWarningDelete(this.TableName, this.APIName);
  	  	},
        tableSendEmail(name) {
            var self = this;
            $(name + " tbody").on( "click", ".tableSendEmail", function() {
                self.selectedResetEmail = $(this).data().passingemail;

                EventBus.$emit("confirmDialog", {
                    text: "Are you sure to reset this user password? ",
                    description: "The user will receive an reset password email to complete this process.",
                    receivingMethodName: "SendPasswordResetCode",
                });
            });
        },
        confirmResetPasswordCode() {
            var self = this;
            axios({
                method: "POST",
                url: "Account/SendPasswordResetCode",
                data: {
                    "emailAddress": self.selectedResetEmail
                }
            })
                .then(function (response) {
                    EventBus.$emit("snackBar", {
                        text: "Reset password email had send to " + self.selectedResetEmail,
                        snackbarColor: "green darken-2"
                    });
                    self.$emit("update:SendPasswordResetCode", false);
                });
        },
  	  	tableUserEdit(name, link) {
  	  		var self = this;
  	  		$(name + " tbody").on( "click", ".tableUserEdit", function() {
  	  		  var id = $(this).data().passingid ;
  	  		  self.getUser(id);
  	  		  self.getRoles();
  	  		  self.getDepartment();
  	  		  self.SelectedId = id;
  	  		});
  	  	},
        tableActionDelete(name) {
            var self = this;
            $(name + " tbody").on( "click", ".tableActionDelete", function() {
                var id = $(this).data().passingid ;
                self.SelectedId = id;
                self.isDeleteDialog = true;
            });
        },
        async confirmDeleteUser() {
            this.isDeleteDialog = false;
            let res = await deleteUser({ "id": this.SelectedId });
            if (res) {
                EventBus.$emit("snackBar", {
                    text: "User Deleted Succesfully",
                    snackbarColor: "green darken-2"
                });
                this.reloadTable("#userList");
            }
        },
  	  	getUser(id) {
  	  		var self = this;
  	  		axios({
  	  		  method: "GET",
  	  		  url: "User/Get",
  	  		  params: {
  	  		    Id: id
  	  		  }
  	  		})
  	  		.then(function (response) {
  	  			self.editUserDialog = true;
  	  			self.selectedDepartment = response.data.result.departmentId;
  	  			self.selectedRole = response.data.result.roleNames;
  	  			self.name = response.data.result.name;
  	  			self.surname = response.data.result.surname;
  	  			self.userName = response.data.result.userName;
  	  			self.emailAddress = response.data.result.emailAddress;
  	  		});
  	  	},
  	  	EditUser() {
  	  		var self = this;
  	  		this.$validator.validateAll().then(result => {
  	  		  if (result) {
                    EventBus.$emit("confirmDialog", {
                        text: "Are you sure to edit this ?",
                        id: 1,
                    });
  	  		  }
  	  		  self.editUserDialog = false;
  	  		});
  	  	},
  	  	comfirmUpdateUser() {
            var self = this;
            axios({
                method: "PUT",
                url: "User/Update",
                data: {
                    "departmentId": this.selectedDepartment,
                    "roleId": this.selectedRole,
                    "name": this.name,
                    "surname": this.surname,
                    "userName": this.userName,
                    "emailAddress": this.emailAddress,
                    "resetPassword": this.password,
                    "isActive": true,
                    "id": this.SelectedId,
                    "tenantId": 1,
                }
            })
                .then(function (response) {
                    EventBus.$emit("snackBar", {
                        text: "User Updated Succesfully",
                        snackbarColor: "green darken-2"
                    });
                    self.selectedRole = null;
                    self.selectedDepartment = null;
                    self.$emit("update:comfirmFn", false);
                    self.reloadTable("#userList");
                });
  	  	},
  	  	comfirmPassword() {
  	  		var self = this;
  	  		axios({
  	  		  method: "DELETE",
  	  		  url: this.$store.state.itemAPIName + "/Delete",
  	  		  params: {
  	  		    Id: this.$store.state.itemID
  	  		  }
  	  		}).then(function (response) {
                EventBus.$emit("snackBar", {
                    text: "Role Updated Succesfully",
                    snackbarColor: "green darken-2"
                });
                self.reloadTable("#userList");
  	  		});
  	  	},
        async getRoles() {
            let res = await roleGetAllForDropdown();
            if (res) {
                this.RoleOptions = res;
            }
        },
  	  	getDepartment() {
  	  		var self = this;
  	  		axios({
  	  		  method: "GET",
  	  		  url: "Department/GetAllForDropdown",
  	  		})
  	  		.then(function (response) {
  	  		  self.DepartmentOptions = response.data.result;
  	  		});
  	  	},
    }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/UMS/UserManagement/UserTable.vue